import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "#BC5806",
        d: "m24.0565 32.6335-18 5.8683V22.5332h18z"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#D67D41",
        d: "M8.5959 6h15.7429v16.0815H6.0567V8.5392A2.5286 2.5286 0 0 1 8.5959 6"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#D67D41",
        d: "M16.4953 29.6428c1.6364-.9592 1.4671-2.7084.5643-4.1755-.4514-.6771.0564-1.58.9028-1.58h6.0941l.0564-3.9498H6.0565v3.9498h6.0376c.79 0 1.2978.8464.9028 1.5235-.5642 1.0157-1.0721 1.9749-.4514 3.1035.7335 1.4106 2.5956 1.9185 3.9498 1.1285"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#F49351",
        d: "M18.3008 16.326c.9592 1.6364 2.7085 1.4671 4.1756.5643.6771-.4514 1.5799.0564 1.5799.8464v6.1505l17.9436.0564V8.652c0-1.467-1.185-2.652-2.6521-2.652H24.0563v5.9812c0 .7899-.8464 1.2978-1.5235.9028-1.1286-.6207-2.2007-1.1849-3.4985-.2257-1.1285.8464-1.4671 2.4263-.7335 3.6677"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFB583",
        d: "M31.6176 18.188c-1.6364.9592-1.4671 2.7085-.5643 4.1755.4514.6772-.0564 1.58-.8464 1.58h-6.1505L24 41.887h15.348c1.467 0 2.652-1.1849 2.652-2.652V23.9435h-6.0376c-.79 0-1.2978-.8464-.9028-1.5236.6207-1.1285 1.1849-2.2006.2257-3.4984-.8464-1.1849-2.4828-1.4671-3.6677-.7335"
    }, "4"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#BC5806",
        d: "M29.7555 31.5044c-.9593-1.6364-2.7085-1.4671-4.1756-.5643-.6771.4515-1.5799-.0564-1.5799-.8463-1.3542 1.0721-4.0063 2.8777-7.7304 3.7241-4.6834 1.0721-8.5204.1128-10.2696-.395v5.8119c0 1.4671 1.185 2.652 2.652 2.652h15.2916v-6.0376c0-.79.8464-1.2978 1.5235-.9028 1.1285.6207 2.2006 1.185 3.4984.2257 1.185-.8464 1.5235-2.4827.79-3.6677"
    }, "5"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#662B02",
        d: "M37.4859 34.665c0 .4514-.0564.8464-.2256 1.1285-.1693.2822-.395.5643-.6772.7336-.2821.1692-.5642.3385-.9592.395-.3386.0564-.6772.1128-1.0721.1128h-3.047v-8.2947h3.047c.2821 0 .6207.0565.9028.1129q.4232.0846.8464.3385c.2257.1693.4514.395.6207.6772s.2257.6207.2257 1.0721-.1129.8464-.3386 1.1285-.5078.5078-.9028.6771c.2257.0564.395.1129.6207.2257.1693.1129.3386.2257.5078.395.1129.1693.2257.3386.3386.5643.0564.1692.1128.4514.1128.7335m-2.0877-3.4984c0-.2822-.1129-.5079-.2822-.6207s-.5078-.1693-.9028-.1693h-.9028v1.6928h1.0157c.3385 0 .6206-.0564.7899-.2257s.2822-.395.2822-.6771m.2257 3.2727c0-.3386-.1129-.5643-.3386-.7336a2.18 2.18 0 0 0-.9592-.2256h-1.0157v1.9184h1.0157c.1693 0 .2821 0 .4514-.0564.1693 0 .2821-.0564.395-.1693.1128-.0564.2257-.1692.2821-.2821.1693-.0564.1693-.2257.1693-.4514"
    }, "6")
], "AppBidModel", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
